import { Component, computed, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AuthService } from './auth/services/auth';
import { LoadingComponent } from './shared/components/loading/loading';
import { ConfirmDialog } from './shared/components/confirm-dialog/confirm-dialog';
import { NotificacionDialog } from './shared/components/notificacion-dialog/notificacion-dialog';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent, ConfirmDialog, NotificacionDialog],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class App implements OnInit {
  private authService = inject(AuthService);
  protected title = 'frontend-v2-ng';

  public finishedAuthCheck = computed<boolean>(() => {
    return true;
  });


  ngOnInit() {
    // Verificar autenticación al inicializar la app
    console.log('App initialized - Auth status:', this.authService.isAuthenticated());
  }
}
